import React from 'react'
import { logoData } from './logoData'
import './index.less'
//import {Button} from "../../../../components";
import {diffEndJump} from "../../../../utils/tools";
import {URL_MORE_USER_PC} from "../../../../constants/CyHomepage";
import USER_MORE from "../../../../assets/images/cy/user_more.png";

const clsPrefix = 'c-users-panel'
const UsersPanel: React.FC<{
    isInScreen: boolean
}> = ({
          isInScreen = true
      }) => {
    //const isShow = useContext(IsShowContext)

    function handleMore () {
        // @ts-ignore
        if (window && window.xqui && window.xqui.useStat) {
            // @ts-ignore
            window.xqui.useStat({
                category: 'kz_site_click_register',
                page: 'kz_homepage',
                action: 'click',
                bizType: 2,
            })
        }
        // @ts-ignore
        diffEndJump({
            href: URL_MORE_USER_PC,
            //wapHref: URL_REGISTER_WAP,
            isOpenNewWindow: true
        })
    }

    return (
        <div className={clsPrefix}>
            <div className={`${clsPrefix}__transitional-words ${isInScreen ? 'animated fadeIn' : ''}`} style={{ animationDuration: '1.5s' }}>
                <p className='emphasis-text'>他们都在用畅言云评
                    <a className='more_user' href='#' onClick={handleMore}><img src={USER_MORE}></img></a>
                </p>
                <span className='shallow-text'>来自政府组织、互联网、媒体、教育等各个行业的用户</span>
                <span className='shallow-text'>以下为友情链接</span>
            </div>
            <div className={`${clsPrefix}__users`}>
                <ul className={`${clsPrefix}--ul ${isInScreen ? 'animated fadeInUp' : ''}`} style={{ animationDuration: '1.5s' }}>
                    {
                        logoData.map(item => (
                            <li key={item.alt} className={`${clsPrefix}--li`}>
                                <a href={item.link} target='_blank' rel='nofollow'>
                                    <img
                                        alt={item.alt}
                                        src={item.src}
                                        className={`${clsPrefix}--logo`}
                                    />
                                </a>
                            </li>
                        ))
                    }
                </ul>
            </div>
        </div>
    )
}

export { UsersPanel }

